import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../store/modules/ModalActions';
import { GenericModal } from '../GenericModal';
import HistoricoItem from './HistoricoItem';

class HistoricoAnaliseOperacionalModal extends Component {
  getTitle() {
    return this.props.languageValues
      .cadastroContratoHistoricoAnaliseOperacional;
  }

  sortId = (a, b) => {
    return a.id < b.id ? 1 : -1;
  };

  getHistorico = () => {
    return this.props.historico.sort(this.sortId);
  };

  render() {
    return (
      <GenericModal
        onClose={() => {
          this.props.closeModal(this.props.modalKey);
        }}
        DialogProps={{
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        }}
        title={this.getTitle()}
      >
        {this.getHistorico().map((item, index) => {
          return (
            <HistoricoItem
              item={item}
              index={index}
              utils={this.props.utils}
              key={index}
            />
          );
        })}
      </GenericModal>
    );
  }
}

HistoricoAnaliseOperacionalModal.propTypes = {
  utils: PropTypes.object.isRequired,
  modalKey: PropTypes.string.isRequired,
  historico: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoricoAnaliseOperacionalModal);
